// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22ohJ","field":"styles_field__1gaNU","fieldCol":"styles_fieldCol__Iu8L4","diffCol":"styles_diffCol__1myyu","diff":"styles_diff__3EgEC"};